import { render, staticRenderFns } from "./StudentAdd.vue?vue&type=template&id=401b5bd5&"
import script from "./StudentAdd.vue?vue&type=script&lang=js&"
export * from "./StudentAdd.vue?vue&type=script&lang=js&"
import style0 from "./StudentAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports